module.exports = __webpack_public_path__ + "static/media/filetype-json.b7799308.svg";